import { BASE_URL_PROMO_CODE } from '../constants';

class uploadImageCustomizeApi {

    static doImageUploadCustomize(data) {
        const formData = new FormData()
        formData.append('file', data.imageUpload)


        try {
            const ajaxRequestHeaders = new Headers({
                "User-Agent": "PostmanRuntime/7.20.1",
                "Accept": "*/*",
                "Cache-Control": "no-cache",
                "Postman-Token": "98d7681a-e8dc-4eaa-8e60-ffc7e23523e4,3526baca-48c0-4c42-9fd8-9346acf0622a",
                "Host": "reservationsbackend.azurewebsites.net",
                "Accept-Encoding": "gzip, deflate",
                "Cookie": ".AspNetCore.Session=CfDJ8NdWEt4XJD1Fkq8bet9L0lndzo4hb7oPG3t8c%2FQFn03VuYRYTb8uKyMkl98%2FwnVGzbVXR4wsrVXVVRQSrYWrU1cSuVMoE%2FHXFoocbHy38s8yxBV0rF2JM87jj3krOQI0HOZ2wCv7CgWPhuGKr2t4X5aByPCFMi51nfTIRq4vhL7V",
                "Content-Length": "0",
                "Connection": "keep-alive",
                "cache-control": "no-cache",
                mimeType: 'multipart/form-data',
                // 'Authorization': 'Bearer ' + TOKEN
            });

            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: formData
            }
            return fetch(BASE_URL_PROMO_CODE + 'uploadImage', body).then(response => {
                // if(response.status === 401) {
                //     localStorage.clear()
                //     window.location.href ='/'
                // }
                return response.json();
            }).catch(error => {
                return error;
            });
        } catch (error) {

        }
    }
}
export default uploadImageCustomizeApi